import { createUseStyles } from 'react-jss'

import config from 'styles/config'
import { textSize, titleFont, regularFontItalic, color } from '@portal/kit/pkg/styles'

const { boxMobileMargin, boxMargin } = config.dimensions

const dashboardStyles = createUseStyles(theme => ({
  welcomeText: {
    paddingRight: 84,
    ...textSize(20, 24),
    ...titleFont(),
  },
  welcomeTextWelcome: {
    display: 'block',
    color: theme.main_color,
  },
  welcomeIcon: {
    ...color('boxIcon'),
    fontSize: 64,
    position: 'absolute',
    right: 33,
    bottom: -6,
  },
  ranPromoTextbox: {
    marginRight: -13,
    paddingRight: '37%',
    backgroundImage: 'url(/images/WiFi-prive-ad.jpg)',
    backgroundSize: '39% auto',
    backgroundPosition: 'bottom right',
  },
  ranPromoTitle: {
    ...textSize(16, 19),
    ...titleFont(),
    marginBottom: 10,
  },
  ranPromoText: {
    ...textSize(12, 15),
    marginBottom: 18,
  },
  advertisementImgWrap: {
    position: 'relative',
    margin: `-${boxMobileMargin}px -${boxMobileMargin}px ${boxMobileMargin}px -${boxMobileMargin}px`,
  },
  advertisementImg: {
    display: 'block',
    width: '100%',
    paddingBottom: '45%',
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  },
  advertisementTitle: {
    ...titleFont(),
    ...textSize(16, 19),
    marginBottom: 8,
  },
  advertisementContent: {
    ...textSize(14, 19),
    marginBottom: 16,
  },
  advertisementSignature: {
    ...regularFontItalic(),
    ...textSize(14, 15),
  },
  [config.mediaQueries.phonePortraitLarge]: {
    ranPromoTextbox: {
      backgroundSize: 'auto 110%',
    },
  },
  [config.mediaQueries.tabletPortrait]: {
    welcomeText: {
      paddingRight: 110,
      ...textSize(26, 32),
    },
    welcomeIcon: {
      fontSize: 84
    },
    ranPromoTextbox: {
      marginRight: 0,
      padding: '16px 226px 16px 0',
      backgroundSize: '220px auto',
    },
    ranPromoTitle: {
      ...textSize(18, 22),
      marginBottom: 8,
    },
    ranPromoText: {
      ...textSize(13, 16),
      marginBottom: 22,
    },
    advertisementImgWrap: {
      margin: `-${boxMargin}px -${boxMargin}px ${boxMargin}px -${boxMargin}px`,
      borderRadius: '5px 5px 0 0',
    },
    advertisementContent: {
      marginBottom: 8,
    },
  }
}))

export default dashboardStyles
